/**
 * Custom Timeline Component
 * Extends Ant Design Timeline with custom styling
 */

import { Timeline as AntTimeline, TimelineProps } from 'antd';
import classNames from 'classnames';
import './CustomTimeline.scss';

export interface CustomTimelineProps extends TimelineProps {
  /** Timeline variant */
  variant?: 'default' | 'alternate' | 'colored';
}

/**
 * CustomTimeline Component
 */
export const CustomTimeline: React.FC<CustomTimelineProps> = ({
  variant = 'default',
  className,
  ...rest
}) => {
  const timelineClasses = classNames('custom-timeline', `custom-timeline--${variant}`, className);

  return <AntTimeline {...rest} className={timelineClasses} />;
};

export const CustomTimelineItem = AntTimeline.Item;

export default CustomTimeline;

